import './style.css'

// Trip Planner Application Logic

// Destination Database
const destinations = [
    {
        name: "Goa",
        region: "west",
        tripTypes: ["leisure", "beach", "mixed"],
        climate: "warm",
        icon: "🏖️",
        description: "Perfect beach destination with family-friendly resorts, water sports, and Portuguese heritage sites.",
        highlights: ["Beach Activities", "Water Sports", "Heritage Sites", "Seafood", "Nightlife"],
        familyFeatures: {
            kidsActivities: ["Beach play", "Dolphin watching", "Water parks"],
            elderFriendly: true,
            medicalFacilities: "Excellent",
            accessibility: "Good",
            foodOptions: "Mixed, Vegetarian available"
        },
        bestFor: ["families with kids", "beach lovers", "adventure seekers"],
        budgetRange: ["moderate", "comfortable", "luxury"],
        duration: [3, 7]
    },
    {
        name: "Manali",
        region: "north",
        tripTypes: ["adventure", "hill-station", "leisure"],
        climate: "cold",
        icon: "🏔️",
        description: "Scenic hill station with snow-capped mountains, temples, and adventure activities.",
        highlights: ["Snow Activities", "Rohtang Pass", "Solang Valley", "Hadimba Temple", "River Rafting"],
        familyFeatures: {
            kidsActivities: ["Snow play", "Cable car rides", "Nature walks"],
            elderFriendly: false,
            medicalFacilities: "Good",
            accessibility: "Moderate",
            foodOptions: "North Indian, Vegetarian friendly"
        },
        bestFor: ["adventure families", "nature lovers", "young families"],
        budgetRange: ["moderate", "comfortable"],
        duration: [4, 7]
    },
    {
        name: "Kerala (Munnar & Alleppey)",
        region: "south",
        tripTypes: ["leisure", "cultural", "wildlife"],
        climate: "moderate",
        icon: "🌴",
        description: "God's Own Country with backwaters, tea gardens, wildlife, and authentic South Indian culture.",
        highlights: ["Houseboat Stay", "Tea Gardens", "Ayurveda", "Wildlife", "Beaches"],
        familyFeatures: {
            kidsActivities: ["Houseboat ride", "Tea estate tours", "Wildlife spotting"],
            elderFriendly: true,
            medicalFacilities: "Excellent",
            accessibility: "Good",
            foodOptions: "South Indian, Vegetarian & Non-veg"
        },
        bestFor: ["multi-generation families", "relaxation seekers", "nature lovers"],
        budgetRange: ["comfortable", "luxury"],
        duration: [5, 10]
    },
    {
        name: "Jaipur",
        region: "north",
        tripTypes: ["cultural", "heritage", "leisure"],
        climate: "warm",
        icon: "🕌",
        description: "The Pink City with magnificent forts, palaces, and rich Rajasthani culture.",
        highlights: ["Amber Fort", "City Palace", "Hawa Mahal", "Local Cuisine", "Shopping"],
        familyFeatures: {
            kidsActivities: ["Elephant rides", "Palace tours", "Cultural shows"],
            elderFriendly: true,
            medicalFacilities: "Excellent",
            accessibility: "Good",
            foodOptions: "Rajasthani, Vegetarian friendly"
        },
        bestFor: ["history buffs", "cultural explorers", "all age groups"],
        budgetRange: ["budget", "moderate", "comfortable"],
        duration: [3, 5]
    },
    {
        name: "Andaman Islands",
        region: "east",
        tripTypes: ["beach", "adventure", "leisure"],
        climate: "warm",
        icon: "🏝️",
        description: "Pristine beaches, crystal-clear waters, and untouched natural beauty.",
        highlights: ["Snorkeling", "Scuba Diving", "Cellular Jail", "Beach Hopping", "Seafood"],
        familyFeatures: {
            kidsActivities: ["Beach activities", "Glass-bottom boat", "Sea walking"],
            elderFriendly: true,
            medicalFacilities: "Good",
            accessibility: "Moderate",
            foodOptions: "Mixed, Seafood, Vegetarian available"
        },
        bestFor: ["beach families", "water sports enthusiasts", "photographers"],
        budgetRange: ["comfortable", "luxury"],
        duration: [5, 10]
    },
    {
        name: "Shimla & Kufri",
        region: "north",
        tripTypes: ["hill-station", "leisure", "adventure"],
        climate: "cold",
        icon: "⛰️",
        description: "Colonial charm meets natural beauty in this classic hill station.",
        highlights: ["Mall Road", "Jakhu Temple", "Toy Train", "Snow Point", "Apple Orchards"],
        familyFeatures: {
            kidsActivities: ["Toy train ride", "Ice skating", "Pony rides"],
            elderFriendly: true,
            medicalFacilities: "Good",
            accessibility: "Good",
            foodOptions: "North Indian, Vegetarian friendly"
        },
        bestFor: ["all age groups", "first-time hill station visitors", "weekend trips"],
        budgetRange: ["budget", "moderate", "comfortable"],
        duration: [3, 5]
    },
    {
        name: "Udaipur",
        region: "north",
        tripTypes: ["cultural", "heritage", "leisure"],
        climate: "moderate",
        icon: "🏰",
        description: "The City of Lakes with romantic palaces, serene lakes, and royal heritage.",
        highlights: ["Lake Pichola", "City Palace", "Boat Rides", "Cultural Shows", "Shopping"],
        familyFeatures: {
            kidsActivities: ["Boat rides", "Palace tours", "Puppet shows"],
            elderFriendly: true,
            medicalFacilities: "Excellent",
            accessibility: "Excellent",
            foodOptions: "Rajasthani, Pure Vegetarian available"
        },
        bestFor: ["romantic families", "culture seekers", "peaceful getaways"],
        budgetRange: ["moderate", "comfortable", "luxury"],
        duration: [3, 5]
    },
    {
        name: "Rishikesh & Haridwar",
        region: "north",
        tripTypes: ["pilgrimage", "adventure", "cultural"],
        climate: "moderate",
        icon: "🕉️",
        description: "Spiritual centers with Ganga Aarti, yoga, and adventure activities.",
        highlights: ["Ganga Aarti", "River Rafting", "Beatles Ashram", "Laxman Jhula", "Yoga"],
        familyFeatures: {
            kidsActivities: ["River rafting", "Beach camping", "Temple visits"],
            elderFriendly: true,
            medicalFacilities: "Good",
            accessibility: "Good",
            foodOptions: "Pure Vegetarian only"
        },
        bestFor: ["spiritual families", "adventure seekers", "vegetarian families"],
        budgetRange: ["budget", "moderate"],
        duration: [3, 5]
    },
    {
        name: "Ooty",
        region: "south",
        tripTypes: ["hill-station", "leisure", "wildlife"],
        climate: "cold",
        icon: "🚂",
        description: "Queen of Hill Stations with tea gardens, toy train, and pleasant weather.",
        highlights: ["Toy Train", "Botanical Garden", "Ooty Lake", "Tea Estates", "Doddabetta Peak"],
        familyFeatures: {
            kidsActivities: ["Toy train ride", "Boating", "Rose garden"],
            elderFriendly: true,
            medicalFacilities: "Good",
            accessibility: "Good",
            foodOptions: "South Indian, Vegetarian friendly"
        },
        bestFor: ["all age groups", "nature lovers", "peaceful holidays"],
        budgetRange: ["budget", "moderate", "comfortable"],
        duration: [3, 5]
    },
    {
        name: "Agra",
        region: "north",
        tripTypes: ["cultural", "heritage"],
        climate: "warm",
        icon: "🕌",
        description: "Home to the Taj Mahal and other Mughal architectural marvels.",
        highlights: ["Taj Mahal", "Agra Fort", "Fatehpur Sikri", "Local Crafts", "Mughlai Cuisine"],
        familyFeatures: {
            kidsActivities: ["Monument tours", "Wildlife SOS", "Local markets"],
            elderFriendly: true,
            medicalFacilities: "Excellent",
            accessibility: "Good",
            foodOptions: "North Indian, Vegetarian available"
        },
        bestFor: ["history enthusiasts", "photography lovers", "weekend trips"],
        budgetRange: ["budget", "moderate"],
        duration: [2, 3]
    },
    {
        name: "Darjeeling",
        region: "east",
        tripTypes: ["hill-station", "cultural", "leisure"],
        climate: "cold",
        icon: "🍵",
        description: "Tea capital with stunning Himalayan views and colonial charm.",
        highlights: ["Tiger Hill", "Toy Train", "Tea Gardens", "Monasteries", "Kanchenjunga Views"],
        familyFeatures: {
            kidsActivities: ["Toy train ride", "Zoo visit", "Ropeway ride"],
            elderFriendly: true,
            medicalFacilities: "Good",
            accessibility: "Moderate",
            foodOptions: "Mixed, Vegetarian & Non-veg"
        },
        bestFor: ["tea lovers", "mountain enthusiasts", "peaceful families"],
        budgetRange: ["moderate", "comfortable"],
        duration: [4, 7]
    },
    {
        name: "Mysore",
        region: "south",
        tripTypes: ["cultural", "heritage", "leisure"],
        climate: "moderate",
        icon: "👑",
        description: "Cultural capital of Karnataka with palaces, gardens, and silk sarees.",
        highlights: ["Mysore Palace", "Chamundi Hills", "Brindavan Gardens", "Zoo", "Silk Shopping"],
        familyFeatures: {
            kidsActivities: ["Palace light show", "Zoo visit", "Garden fountains"],
            elderFriendly: true,
            medicalFacilities: "Excellent",
            accessibility: "Excellent",
            foodOptions: "South Indian, Vegetarian friendly"
        },
        bestFor: ["culture seekers", "all age groups", "short trips"],
        budgetRange: ["budget", "moderate"],
        duration: [2, 4]
    }
];

// Budget calculation helper
const budgetRanges = {
    budget: { min: 5000, max: 10000 },
    moderate: { min: 10000, max: 20000 },
    comfortable: { min: 20000, max: 40000 },
    luxury: { min: 40000, max: 100000 }
};

// Form state
let currentStep = 1;
let formData = {};

// Initialize the application
document.addEventListener('DOMContentLoaded', function() {
    initializeForm();
    setMinDate();
});

function setMinDate() {
    const startDateInput = document.getElementById('startDate');
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    startDateInput.min = tomorrow.toISOString().split('T')[0];
}

function initializeForm() {
    const form = document.getElementById('tripPlannerForm');
    const nextButtons = document.querySelectorAll('.btn-next');
    const prevButtons = document.querySelectorAll('.btn-prev');

    // Next button handlers
    nextButtons.forEach(button => {
        button.addEventListener('click', function() {
            if (validateStep(currentStep)) {
                collectStepData(currentStep);
                goToStep(currentStep + 1);
            }
        });
    });

    // Previous button handlers
    prevButtons.forEach(button => {
        button.addEventListener('click', function() {
            goToStep(currentStep - 1);
        });
    });

    // Form submission
    form.addEventListener('submit', function(e) {
        e.preventDefault();
        if (validateStep(currentStep)) {
            collectStepData(currentStep);
            generateTripPlan();
        }
    });
}

function validateStep(step) {
    const currentStepElement = document.querySelector(`.form-step[data-step="${step}"]`);
    const requiredFields = currentStepElement.querySelectorAll('[required]');
    let isValid = true;

    requiredFields.forEach(field => {
        if (!field.value || (field.type === 'radio' && !currentStepElement.querySelector(`input[name="${field.name}"]:checked`))) {
            isValid = false;
            field.classList.add('error');
            
            // Add visual feedback
            if (!field.nextElementSibling || !field.nextElementSibling.classList.contains('error-message')) {
                const errorMsg = document.createElement('span');
                errorMsg.className = 'error-message';
                errorMsg.style.color = 'var(--primary-color)';
                errorMsg.style.fontSize = '13px';
                errorMsg.style.marginTop = '4px';
                errorMsg.style.display = 'block';
                errorMsg.textContent = 'This field is required';
                field.parentNode.appendChild(errorMsg);
            }
        } else {
            field.classList.remove('error');
            const errorMsg = field.parentNode.querySelector('.error-message');
            if (errorMsg) errorMsg.remove();
        }
    });

    // Special validation for radio groups
    if (step === 2) {
        const climateRadios = currentStepElement.querySelector('input[name="climate"]:checked');
        if (!climateRadios) {
            isValid = false;
            alert('Please select a climate preference');
        }
    }

    return isValid;
}

function collectStepData(step) {
    const currentStepElement = document.querySelector(`.form-step[data-step="${step}"]`);
    const inputs = currentStepElement.querySelectorAll('input, select, textarea');

    inputs.forEach(input => {
        if (input.type === 'checkbox') {
            formData[input.name] = input.checked;
        } else if (input.type === 'radio') {
            if (input.checked) {
                formData[input.name] = input.value;
            }
        } else {
            formData[input.name] = input.value;
        }
    });
}

function goToStep(step) {
    // Update current step
    currentStep = step;

    // Hide all steps
    document.querySelectorAll('.form-step').forEach(stepElement => {
        stepElement.classList.remove('active');
    });

    // Show current step
    document.querySelector(`.form-step[data-step="${step}"]`).classList.add('active');

    // Update step indicator
    document.querySelectorAll('.step').forEach((stepIndicator, index) => {
        const stepNumber = stepIndicator.querySelector('.step-number');
        const stepLabel = stepIndicator.querySelector('.step-label');
        
        if (index + 1 < step) {
            // Completed step
            stepIndicator.classList.add('completed');
            stepIndicator.classList.remove('active');
            stepNumber.classList.remove('bg-gray-300', 'text-gray-600');
            stepNumber.classList.add('bg-primary', 'text-white');
            stepLabel.classList.remove('text-gray-600');
            stepLabel.classList.add('text-gray-900', 'font-semibold');
        } else if (index + 1 === step) {
            // Active step
            stepIndicator.classList.add('active');
            stepIndicator.classList.remove('completed');
            stepNumber.classList.remove('bg-gray-300', 'text-gray-600');
            stepNumber.classList.add('bg-primary', 'text-white');
            stepLabel.classList.remove('text-gray-600');
            stepLabel.classList.add('text-gray-900', 'font-semibold');
        } else {
            // Future step
            stepIndicator.classList.remove('active', 'completed');
            stepNumber.classList.remove('bg-primary', 'text-white');
            stepNumber.classList.add('bg-gray-300', 'text-gray-600');
            stepLabel.classList.remove('text-gray-900', 'font-semibold');
            stepLabel.classList.add('text-gray-600');
        }
    });

    // Scroll to top of form
    document.getElementById('planner').scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function generateTripPlan() {
    // Show loading state
    const submitButton = document.querySelector('.btn-submit');
    const originalText = submitButton.textContent;
    submitButton.innerHTML = '<span class="loading"></span> Generating your plan...';
    submitButton.disabled = true;

    // Simulate processing time for better UX
    setTimeout(() => {
        // Calculate recommendations
        const recommendedDestinations = getRecommendedDestinations();
        const budgetBreakdown = calculateBudget();
        const itinerary = generateItinerary(recommendedDestinations[0]);
        const tips = generateTips();

        // Display results
        displayResults(recommendedDestinations, budgetBreakdown, itinerary, tips);

        // Reset button
        submitButton.textContent = originalText;
        submitButton.disabled = false;

        // Scroll to results
        document.getElementById('results').scrollIntoView({ behavior: 'smooth' });
    }, 2000);
}

function getRecommendedDestinations() {
    const familySize = parseInt(formData.adults) + parseInt(formData.children) + parseInt(formData.elders);
    const hasChildren = parseInt(formData.children) > 0;
    const hasElders = parseInt(formData.elders) > 0;
    
    let scoredDestinations = destinations.map(dest => {
        let score = 0;

        // Region match
        if (formData.region === 'any' || dest.region === formData.region) {
            score += 20;
        }

        // Trip type match
        if (dest.tripTypes.includes(formData.tripType)) {
            score += 25;
        }

        // Climate match
        if (formData.climate === 'any' || dest.climate === formData.climate) {
            score += 15;
        }

        // Budget match
        if (dest.budgetRange.includes(formData.budget)) {
            score += 15;
        }

        // Duration compatibility
        const tripDuration = parseInt(formData.duration);
        if (tripDuration >= dest.duration[0] && tripDuration <= dest.duration[1]) {
            score += 10;
        }

        // Family-friendly factors
        if (hasElders && dest.familyFeatures.elderFriendly) {
            score += 15;
        }

        if (formData.wheelchairAccess && dest.familyFeatures.accessibility === 'Excellent') {
            score += 10;
        }

        if (formData.medicalFacilities && dest.familyFeatures.medicalFacilities === 'Excellent') {
            score += 10;
        }

        // Food preference match
        if (formData.foodPreference === 'vegetarian' || formData.foodPreference === 'jain') {
            if (dest.familyFeatures.foodOptions.includes('Vegetarian') || 
                dest.familyFeatures.foodOptions.includes('Pure Vegetarian')) {
                score += 10;
            }
        }

        return { ...dest, score };
    });

    // Sort by score and return top 3
    scoredDestinations.sort((a, b) => b.score - a.score);
    return scoredDestinations.slice(0, 3);
}

function calculateBudget() {
    const familySize = parseInt(formData.adults) + parseInt(formData.children) + parseInt(formData.elders);
    const duration = parseInt(formData.duration);
    const budgetRange = budgetRanges[formData.budget];
    
    // Base per person per day
    const perPersonPerDay = (budgetRange.min + budgetRange.max) / 2 / duration;

    // Calculate components
    const accommodation = perPersonPerDay * 0.35 * duration * familySize;
    const food = perPersonPerDay * 0.30 * duration * familySize;
    const transportation = perPersonPerDay * 0.20 * duration * familySize;
    const activities = perPersonPerDay * 0.10 * duration * familySize;
    const miscellaneous = perPersonPerDay * 0.05 * duration * familySize;

    const total = accommodation + food + transportation + activities + miscellaneous;

    return {
        accommodation: Math.round(accommodation),
        food: Math.round(food),
        transportation: Math.round(transportation),
        activities: Math.round(activities),
        miscellaneous: Math.round(miscellaneous),
        total: Math.round(total),
        perPerson: Math.round(total / familySize),
        familySize
    };
}

function generateItinerary(destination) {
    const duration = parseInt(formData.duration);
    const hasChildren = parseInt(formData.children) > 0;
    const hasElders = parseInt(formData.elders) > 0;
    
    let itinerary = [];

    // Generate day-by-day plan
    for (let day = 1; day <= Math.min(duration, 5); day++) {
        let dayPlan = {
            day: day,
            title: `Day ${day}`,
            activities: []
        };

        if (day === 1) {
            dayPlan.title = "Day 1 - Arrival";
            dayPlan.activities = [
                { time: "Morning", title: "Arrival & Check-in", description: "Arrive at destination, check into hotel, and freshen up" },
                { time: "Afternoon", title: "Lunch & Rest", description: "Have lunch and rest after journey" },
                { time: "Evening", title: "Local Exploration", description: "Light local sightseeing and dinner" }
            ];
        } else if (day === duration && duration <= 5) {
            dayPlan.title = `Day ${day} - Departure`;
            dayPlan.activities = [
                { time: "Morning", title: "Breakfast & Check-out", description: "Have breakfast and pack up" },
                { time: "Late Morning", title: "Last Minute Shopping", description: "Buy souvenirs and local specialties" },
                { time: "Afternoon", title: "Departure", description: "Depart for home" }
            ];
        } else {
            dayPlan.activities = [
                { time: "Morning", title: destination.highlights[day % destination.highlights.length], 
                  description: hasChildren ? "Family-friendly tour with breaks" : "Detailed exploration" },
                { time: "Afternoon", title: "Lunch & Leisure", description: "Local cuisine and relaxation" },
                { time: "Evening", title: destination.highlights[(day + 1) % destination.highlights.length], 
                  description: hasElders ? "Comfortable evening activity" : "Evening activities" }
            ];
        }

        itinerary.push(dayPlan);
    }

    return itinerary;
}

function generateTips() {
    const hasChildren = parseInt(formData.children) > 0;
    const hasElders = parseInt(formData.elders) > 0;
    const hasInfant = formData.infantFriendly;

    let tips = [
        {
            icon: "📱",
            title: "Stay Connected",
            description: "Download offline maps and keep emergency contacts handy. Share your itinerary with family back home."
        },
        {
            icon: "💊",
            title: "Health & Safety",
            description: "Carry basic first-aid kit, prescribed medications, and travel insurance documents."
        },
        {
            icon: "🎒",
            title: "Pack Smart",
            description: "Pack according to weather. Carry comfortable walking shoes and weather-appropriate clothing."
        }
    ];

    if (hasChildren) {
        tips.push({
            icon: "👶",
            title: "Traveling with Kids",
            description: "Keep snacks, entertainment, and favorite toys handy. Plan shorter activities with breaks in between."
        });
    }

    if (hasElders) {
        tips.push({
            icon: "👴",
            title: "Elder Care",
            description: "Plan a relaxed pace with plenty of rest time. Choose accommodations near medical facilities. Carry all medications."
        });
    }

    if (hasInfant) {
        tips.push({
            icon: "🍼",
            title: "Infant Essentials",
            description: "Pack extra diapers, formula/baby food, and sanitizing supplies. Choose infant-friendly accommodations."
        });
    }

    if (formData.foodPreference === 'vegetarian' || formData.foodPreference === 'jain') {
        tips.push({
            icon: "🥗",
            title: "Food Options",
            description: "Research vegetarian restaurants in advance. Many hotels offer Jain food on request."
        });
    }

    tips.push({
        icon: "💰",
        title: "Budget Management",
        description: "Keep some buffer in budget for unexpected expenses. Carry mix of cash and cards."
    });

    return tips;
}

function displayResults(destinations, budget, itinerary, tips) {
    // Show results section
    const resultsSection = document.getElementById('results');
    resultsSection.style.display = 'block';

    // Display trip summary
    displayTripSummary();

    // Display destinations
    displayDestinations(destinations);

    // Display budget
    displayBudget(budget);

    // Display itinerary
    displayItinerary(itinerary, destinations[0]);

    // Display tips
    displayTips(tips);
}

function displayTripSummary() {
    const summaryContainer = document.getElementById('tripSummary');
    const familySize = parseInt(formData.adults) + parseInt(formData.children) + parseInt(formData.elders);
    
    const startDate = new Date(formData.startDate);
    const formattedDate = startDate.toLocaleDateString('en-IN', { 
        day: 'numeric', 
        month: 'long', 
        year: 'numeric' 
    });

    summaryContainer.innerHTML = `
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            <div class="p-4 bg-gray-50 rounded-lg">
                <div class="text-xs text-gray-600 uppercase tracking-wide mb-1">Family Name</div>
                <div class="text-lg font-semibold text-gray-900">${formData.familyName}</div>
            </div>
            <div class="p-4 bg-gray-50 rounded-lg">
                <div class="text-xs text-gray-600 uppercase tracking-wide mb-1">Group Size</div>
                <div class="text-lg font-semibold text-gray-900">${familySize} People</div>
            </div>
            <div class="p-4 bg-gray-50 rounded-lg">
                <div class="text-xs text-gray-600 uppercase tracking-wide mb-1">Travel Date</div>
                <div class="text-lg font-semibold text-gray-900">${formattedDate}</div>
            </div>
            <div class="p-4 bg-gray-50 rounded-lg">
                <div class="text-xs text-gray-600 uppercase tracking-wide mb-1">Duration</div>
                <div class="text-lg font-semibold text-gray-900">${formData.duration} Days</div>
            </div>
            <div class="p-4 bg-gray-50 rounded-lg">
                <div class="text-xs text-gray-600 uppercase tracking-wide mb-1">Trip Type</div>
                <div class="text-lg font-semibold text-gray-900">${capitalizeFirst(formData.tripType)}</div>
            </div>
            <div class="p-4 bg-gray-50 rounded-lg">
                <div class="text-xs text-gray-600 uppercase tracking-wide mb-1">Budget Category</div>
                <div class="text-lg font-semibold text-gray-900">${capitalizeFirst(formData.budget)}</div>
            </div>
        </div>
    `;
}

function displayDestinations(destinations) {
    const container = document.getElementById('destinationsContainer');
    
    container.innerHTML = `
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
            ${destinations.map((dest, index) => `
                <div class="card border border-gray-200 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-lg cursor-pointer">
                    <div class="w-full h-52 bg-gradient-to-br from-purple-600 to-purple-800 flex items-center justify-center text-5xl">${dest.icon}</div>
                    <div class="p-5">
                        <h4 class="text-xl font-semibold mb-2 text-gray-900">${dest.name}</h4>
                        <span class="inline-block bg-green-500 text-white px-3 py-1 rounded-full text-xs font-semibold mb-3">${Math.round((dest.score / 100) * 100)}% Match</span>
                        <p class="text-sm text-gray-600 mb-4 leading-relaxed">${dest.description}</p>
                        <div class="flex flex-wrap gap-2">
                            ${dest.highlights.slice(0, 4).map(highlight => 
                                `<span class="bg-gray-100 text-gray-900 px-3 py-1.5 rounded-full text-xs font-medium">${highlight}</span>`
                            ).join('')}
                        </div>
                        ${index === 0 ? '<p class="mt-3 text-primary font-semibold text-sm">⭐ Top Recommendation</p>' : ''}
                    </div>
                </div>
            `).join('')}
        </div>
    `;
}

function displayBudget(budget) {
    const container = document.getElementById('budgetBreakdown');
    
    container.innerHTML = `
        <table class="w-full border-collapse mt-4">
            <thead>
                <tr>
                    <th class="p-4 text-left border-b border-gray-300 font-semibold text-gray-900 bg-gray-50">Category</th>
                    <th class="p-4 text-left border-b border-gray-300 font-semibold text-gray-900 bg-gray-50">Amount (₹)</th>
                    <th class="p-4 text-left border-b border-gray-300 font-semibold text-gray-900 bg-gray-50">Per Person (₹)</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="p-4 border-b border-gray-300 text-gray-600">Accommodation</td>
                    <td class="p-4 border-b border-gray-300 text-gray-600">₹${budget.accommodation.toLocaleString('en-IN')}</td>
                    <td class="p-4 border-b border-gray-300 text-gray-600">₹${Math.round(budget.accommodation / budget.familySize).toLocaleString('en-IN')}</td>
                </tr>
                <tr>
                    <td class="p-4 border-b border-gray-300 text-gray-600">Food & Dining</td>
                    <td class="p-4 border-b border-gray-300 text-gray-600">₹${budget.food.toLocaleString('en-IN')}</td>
                    <td class="p-4 border-b border-gray-300 text-gray-600">₹${Math.round(budget.food / budget.familySize).toLocaleString('en-IN')}</td>
                </tr>
                <tr>
                    <td class="p-4 border-b border-gray-300 text-gray-600">Transportation</td>
                    <td class="p-4 border-b border-gray-300 text-gray-600">₹${budget.transportation.toLocaleString('en-IN')}</td>
                    <td class="p-4 border-b border-gray-300 text-gray-600">₹${Math.round(budget.transportation / budget.familySize).toLocaleString('en-IN')}</td>
                </tr>
                <tr>
                    <td class="p-4 border-b border-gray-300 text-gray-600">Activities & Sightseeing</td>
                    <td class="p-4 border-b border-gray-300 text-gray-600">₹${budget.activities.toLocaleString('en-IN')}</td>
                    <td class="p-4 border-b border-gray-300 text-gray-600">₹${Math.round(budget.activities / budget.familySize).toLocaleString('en-IN')}</td>
                </tr>
                <tr>
                    <td class="p-4 border-b border-gray-300 text-gray-600">Miscellaneous</td>
                    <td class="p-4 border-b border-gray-300 text-gray-600">₹${budget.miscellaneous.toLocaleString('en-IN')}</td>
                    <td class="p-4 border-b border-gray-300 text-gray-600">₹${Math.round(budget.miscellaneous / budget.familySize).toLocaleString('en-IN')}</td>
                </tr>
                <tr class="bg-gray-50 font-bold">
                    <td class="p-4 text-gray-900 text-lg">Total Estimated Cost</td>
                    <td class="p-4 text-gray-900 text-lg">₹${budget.total.toLocaleString('en-IN')}</td>
                    <td class="p-4 text-gray-900 text-lg">₹${budget.perPerson.toLocaleString('en-IN')}</td>
                </tr>
            </tbody>
        </table>
        <p class="mt-4 text-gray-600 text-sm">
            💡 This is an estimated budget. Actual costs may vary based on specific choices and seasonal pricing.
        </p>
    `;
}

function displayItinerary(itinerary, destination) {
    const container = document.getElementById('itineraryContent');
    
    container.innerHTML = `
        <p class="text-gray-600 mb-6">
            Sample itinerary for <strong>${destination.name}</strong>. This can be customized based on your preferences.
        </p>
        ${itinerary.map(day => `
            <div class="mb-8 pb-8 border-b border-gray-300 last:border-b-0 last:mb-0 last:pb-0">
                <div class="text-xl font-semibold text-primary mb-4">${day.title}</div>
                <div class="flex flex-col gap-3">
                    ${day.activities.map(activity => `
                        <div class="flex gap-4 p-4 bg-gray-50 rounded-lg">
                            <div class="font-semibold text-primary min-w-[80px]">${activity.time}</div>
                            <div class="flex-1">
                                <div class="font-semibold text-gray-900 mb-1">${activity.title}</div>
                                <div class="text-sm text-gray-600">${activity.description}</div>
                            </div>
                        </div>
                    `).join('')}
                </div>
            </div>
        `).join('')}
    `;
}

function displayTips(tips) {
    const container = document.getElementById('tipsContent');
    
    container.innerHTML = `
        <div class="flex flex-col gap-4">
            ${tips.map(tip => `
                <div class="flex gap-4 p-4 bg-gray-50 rounded-lg border-l-4 border-primary">
                    <div class="text-2xl min-w-[32px]">${tip.icon}</div>
                    <div class="flex-1">
                        <div class="font-semibold text-gray-900 mb-1">${tip.title}</div>
                        <div class="text-sm text-gray-600 leading-relaxed">${tip.description}</div>
                    </div>
                </div>
            `).join('')}
        </div>
    `;
}

function capitalizeFirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).replace('-', ' ');
}

function resetPlanner() {
    // Reset form
    document.getElementById('tripPlannerForm').reset();
    
    // Reset form data
    formData = {};
    
    // Go back to step 1
    currentStep = 1;
    goToStep(1);
    
    // Hide results
    document.getElementById('results').style.display = 'none';
    
    // Scroll to planner
    document.getElementById('planner').scrollIntoView({ behavior: 'smooth' });
}

// Smooth scroll for navigation links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });
});

// Expose resetPlanner to global scope for onclick handler
window.resetPlanner = resetPlanner;
